export var KeyboardKey;
(function (KeyboardKey) {
    KeyboardKey["Unknown"] = "Unknown";
    KeyboardKey["Tab"] = "Tab";
    KeyboardKey["Enter"] = "Enter";
    KeyboardKey["Escape"] = "Escape";
    KeyboardKey["Space"] = "Space";
    KeyboardKey["ArrowLeft"] = "ArrowLeft";
    KeyboardKey["ArrowUp"] = "ArrowUp";
    KeyboardKey["ArrowRight"] = "ArrowRight";
    KeyboardKey["ArrowDown"] = "ArrowDown";
    KeyboardKey["Shift"] = "Shift";
    KeyboardKey["Zero"] = "Zero";
    KeyboardKey["Nine"] = "Nine";
    KeyboardKey["A"] = "A";
    KeyboardKey["Z"] = "Z";
    KeyboardKey["ContextMenu"] = "ContextMenu";
    KeyboardKey["One"] = "1";
    KeyboardKey["F6"] = "F6";
    KeyboardKey["F10"] = "F10";
    KeyboardKey["Slash"] = "Slash";
    KeyboardKey["Home"] = "Home";
    KeyboardKey["End"] = "End";
    KeyboardKey["Delete"] = "Delete";
    KeyboardKey["Backspace"] = "Backspace";
})(KeyboardKey || (KeyboardKey = {}));
//# sourceMappingURL=KeyboardKey.js.map